import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-foreground-50" style={{ fontFamily: 'var(--font-heading)' }}>
                韩漫网
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              韩漫网——领先的中文韩漫阅读平台。提供免费下拉式韩漫阅读体验，日更不断，资源全面，为漫画爱好者打造最佳的在线阅读空间。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">
              漫画分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  热门推荐
                </Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  最新更新
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">
              联系我们
            </h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm text-foreground-400">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </div>
                contact@hanmanwang.com
              </div>
              <div className="flex items-center gap-3 text-sm text-foreground-400">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-wechat-line"></i>
                </div>
                hanmanwang_official
              </div>
              <div className="flex items-center gap-3 text-sm text-foreground-400">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-weibo-line"></i>
                </div>
                @韩漫网官方
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; 2026 韩漫网 - 版权所有 | 免费韩漫在线阅读平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}